/**
 * Navbar - Full-width fixed header
 *
 * v11.1: the old floating centered `rounded-full` glass pill read as a search
 * box (an empty frosted capsule = "type here"). A full-width bar with square
 * corners and a hairline bottom border reads as a header, never a field. Logo
 * left + CTA right, no empty middle, no nav links (HubSpot A/B: removing nav
 * links doubled conversions). v11: CTA is the extension (CWS install) — the
 * primary action everywhere; signup lives in the hero's secondary button.
 */

import { CWS_URL } from './ExtensionPromo'
import { useLandingT, usePublicHref } from './landing-locale'

export function Navbar() {
  const t = useLandingT()
  const href = usePublicHref()

  return (
    <header className="fixed inset-x-0 top-0 z-50 bg-surface/70 backdrop-blur-md border-b border-outline-variant/30">
      <div className="mx-auto flex h-14 max-w-5xl items-center justify-between gap-4 px-4 sm:h-16 sm:px-6">
        {/* Logo — brand name is locale-invariant, so the label stays English. */}
        <a
          href={href('/')}
          aria-label="Piccard — home"
          className="flex-none whitespace-nowrap font-headline text-[22px] sm:text-[24px] tracking-tight text-on-surface"
          onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }) }}
        >
          piccard
        </a>

        {/* CTA — extension install, opened in a new tab (external CWS listing).
            Visible text is localized and is the accessible name; no aria-label
            override (that would force English on non-EN screen-reader users). */}
        <a
          href={CWS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex flex-none items-center whitespace-nowrap bg-primary text-on-primary rounded-full px-4 sm:px-6 py-2 font-body text-[13px] sm:text-[14px] font-semibold hover:bg-primary-active transition-colors focus-visible:outline-2 focus-visible:outline-primary focus-visible:outline-offset-2"
        >
          {t('landing.hero.ctaExtension')}
        </a>
      </div>
    </header>
  )
}
